export class TransactionSummary {
    paymentInfo: string;
    amountFormattedForDisplay: string;
    productName: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/receipt/transaction-summary.model.ts